import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mustShow)?_c(VBtn,{attrs:{"icon":"","color":_vm.color,"to":{name:'userDashboard'}}},[_c(VIcon,[_vm._v("security")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }